export default __webpack_public_path__ + "static/media/67.3fb187c4.jpg";